<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<a [href]="'/Test' | safeUrl" target="_self">
					<img style="max-height: 56px" [src]="'/studio/assets/logo.svg' | safeUrl" />
				</a>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
